import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import { get, join, isEmpty } from 'lodash';
import MenuItem from '@material-ui/core/MenuItem';
import {
  AutoComplete,
  DropdownWrapper,
  GridContainer,
  GridItem,
  SwitchWrapper,
  TextFieldWrapper,
} from '../../common';

const DIAGNOSIS = 'icd10Code';
const IS_SEARCH_RESULT = 'isSearchResult';
const CUSTOM = 'custom';
const TREATING_DOCTOR_ID = 'treatingDoctorId';
const NOTES = 'notes';

function Diagnosis({ doctors, paths, onSearch, values }) {
  const isSearchResult = get(values, [...paths, IS_SEARCH_RESULT]);
  const selectedDiagnosis = get(values, [...paths, DIAGNOSIS]);
  return (
    <GridContainer>
      <GridItem xs={12}>
        <Field
          component={SwitchWrapper}
          id={IS_SEARCH_RESULT}
          label="Search By Diagnosis"
          name={join([...paths, IS_SEARCH_RESULT], '.')}
        />
      </GridItem>
      <GridItem lg={6} xs={12}>
        {isSearchResult ? (
          <React.Fragment>
            <Field
              component={AutoComplete}
              defaultSelectedItem={selectedDiagnosis}
              fullWidth
              getSuggestions={onSearch}
              id={DIAGNOSIS}
              label="Diagnosis"
              name={join([...paths, DIAGNOSIS], '.')}
              paths={[...paths, DIAGNOSIS]}
              required
            />
            {selectedDiagnosis && <div>{selectedDiagnosis.code}</div>}
          </React.Fragment>
        ) : (
          <Field
            component={TextFieldWrapper}
            id={CUSTOM}
            label="Custom Diagnosis Name"
            name={join([...paths, CUSTOM], '.')}
            paths={[...paths, CUSTOM]}
            required
          />
        )}
      </GridItem>
      <GridItem sm={6} xs={12}>
        <Field
          component={DropdownWrapper}
          id={TREATING_DOCTOR_ID}
          label="Treating Doctor"
          name={join([...paths, TREATING_DOCTOR_ID], '.')}
          paths={[...paths, TREATING_DOCTOR_ID]}
        >
          {isEmpty(doctors) ? (
            <MenuItem value={undefined}>
              You don't have any saved doctors.
            </MenuItem>
          ) : (
            doctors.map(doctor => (
              <MenuItem
                key={doctor.id || doctor.tempId}
                value={doctor.id || doctor.tempId}
              >
                {doctor.firstName} {doctor.lastName}
              </MenuItem>
            ))
          )}
        </Field>
      </GridItem>
      <GridItem lg={12} xs={12}>
        <Field
          component={TextFieldWrapper}
          id={NOTES}
          label="Notes"
          multiline
          name={join([...paths, NOTES], '.')}
          paths={[...paths, NOTES]}
        />
      </GridItem>
    </GridContainer>
  );
}

Diagnosis.propTypes = {
  onSearch: PropTypes.func.isRequired,
  doctors: PropTypes.array,
  paths: PropTypes.array,
  values: PropTypes.object,
};

Diagnosis.defaultProps = {
  doctors: [],
  paths: [],
  values: {},
};

export default Diagnosis;



// WEBPACK FOOTER //
// ./src/modules/DiagnosisPage/components/Diagnosis.js